import { render, staticRenderFns } from "./Reembolso.vue?vue&type=template&id=1976bbf7&scoped=true"
import script from "./Reembolso.vue?vue&type=script&lang=js"
export * from "./Reembolso.vue?vue&type=script&lang=js"
import style0 from "./Reembolso.vue?vue&type=style&index=0&id=1976bbf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1976bbf7",
  null
  
)

export default component.exports